import constants from './constants';

export function receiveBrand(brand) {
  return {
    type: constants.actions.RECEIVE_BRAND,
    brand,
  };
}

export default {
  receiveBrand,
};
